<script>
export default {
  name: 'ReminderWrapper',
};
</script>
<template>
  <router-view/>
</template>



// WEBPACK FOOTER //
// src/pages/reminders/ReminderWrapper.vue